export const getIdpPartnerLogoutUrl = () =>
  import.meta.env.VITE_IDP_PARTNER_LOGOUT_URL;

export const getFeatureHighlightsContentfulId = () =>
  import.meta.env.VITE_FEATURE_HIGHLIGHTS_CONTENTFUL_ID;
